import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm";

const MatchsMaking = () => {
  return (
    <>
    
    <div className="services-page">
         
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       <h2>Match Making with Jyothis Karmaa</h2>
                  <h2>Introduction</h2>
                <p>
                    The question of choosing the right life partner is one of the most important decisions for any individual. 
                    In Indian culture, particularly among Hindus, astrological match making has always been a deeply trusted 
                    tradition to ensure compatibility, harmony, and long-term happiness in marriage. At Jyothis Karmaa, 
                    we provide detailed and personalized Kundali Milan (match making) services based on ancient Vedic principles.

                    
                </p>


                <h2>Kundali Milan</h2>
                <p>A Traditional Practice with Modern Precision
                    Match making, also known as Gun Milan or Kundli Milan, is a time-tested custom that analyzes birth charts to 
                    assess compatibility between prospective brides and grooms. With the evolution of computer-based astrology, 
                    calculating match scores by date of birth and Nakshatras has become faster and more accessible. 
                    Yet, the spiritual depth and astrological insight behind it remain timeless.   

                </p>
               

                <h2>Ashtakoot Milan</h2>
                <p>The 8-Fold Compatibility System
                         Horoscope matching is done through the Ashtakoot Milan system which assigns a maximum score of
                          36 points. The higher the score, the better the compatibility. The eight kootas and their roles 
                          are as follows:
                </p>
                 <ul className="astro-benefits">
                    <li>
                    <strong>✅ Varna (1 Point):</strong> Represents the spiritual compatibility and ego levels.
                    </li> 
                    <li>
                    <strong>✅ Vashya (2 Points):</strong> Measures mutual attraction and control dynamics.


                    </li>
                    <li>
                    <strong>✅ Tara (3 Points): </strong> Checks destiny and luck alignment.
                    </li>
                    <li>
                    <strong>✅ Yoni (4 Points):</strong> Assesses sexual compatibility and intimacy.
                    </li>

                    <li>
                    <strong>✅ Graha Maitri (5 Points):</strong> Indicates mental compatibility and friendship.
                    </li>

                    <li>
                    <strong>✅ Gana (6 Points):</strong>Reflects temperament and nature compatibility.
                    </li>

                    <li>
                    <strong>✅ Bhakoot (7 Points):</strong> Considers zodiac sign relationships and emotional bonding.
                    </li>

                    <li>
                    <strong>✅ Nadi (8 Points):</strong> Focuses on health and childbirth prospects.
                    </li>
                    
                </ul>
                  

                  <h2> Scoring System in Match Making</h2>
                  

                 
                <ul className="astro-benefits">
                    <li>
                    <strong>✅ Above 30:</strong> Excellent match with strong compatibility.
                    </li> 
                    <li>
                    <strong>✅ 25–30:</strong> Good compatibility with minor adjustments.
                    </li>
                    <li>
                    <strong>✅ 18–24</strong> Average match, may require remedial measures.
                    </li>
                    <li>
                    <strong>✅ Below 18</strong> Not recommended unless special astrological remedies are followed.
                    </li>
                    
                </ul>


                 <h2>Why Choose Jyothis Karmaa for Match Making?</h2>
                  <p>We blend ancient Vedic knowledge with modern technology to deliver:
                  </p>

                 
                <ul className="astro-benefits">
                    <li>
                    <strong>✅ Precise compatibility analysis </strong> 
                    </li> 
                    <li>
                    <strong>✅ In-depth interpretation of strengths and challenges </strong> 
                    </li>
                    <li>
                    <strong>✅ Personalized remedies if match score is low</strong> 
                    </li>
                    
                    
                </ul>


                 <h2>Try Our Match Making Service</h2>
                  <p>We invite you to explore our personalized marriage compatibility service based on your exact date, time, and place of birth. At Jyothis Karmaa, we are committed to helping you find the right match for a happy and harmonious married life.
                  </p>
                 
              

                

        {/* FAQs */}
        <div className="faq-section">
            <h3>Frequently Asked Questions</h3>
            
            <div className="faq">
                <h4>How does Jyothis Karmaa approach astrology?</h4>
                <p>We use a blend of traditional Vedic methods and KP astrology to provide accurate predictions and practical remedies tailored to your birth chart.</p>
            </div>
            
            <div className="faq">
                <h4>What is the importance of Vastu in daily life?</h4>
                <p>Vastu helps in aligning your living or working space with cosmic energies, promoting peace, prosperity, and better decision-making.</p>
            </div>
            
            <div className="faq">
                <h4>Are gemstone recommendations safe and accurate?</h4>
                <p>Yes. We only recommend gemstones after thorough analysis of your birth chart to ensure they're astrologically aligned and effective for your needs.</p>
            </div>
            
            <div className="faq">
                <h4>Can astrology help in legal or court case matters?</h4>
                <p>Absolutely. By analyzing specific houses in your horoscope, we offer guidance and remedies that may help ease litigation-related challenges.</p>
            </div>
            
        </div>


        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <ContactForm />

       
          <ServiceProduts />
        
      </div>
    </div>
    </>
  );
};

export default MatchsMaking;
